import { Paper, Flex, Text, Button, ThemeIcon } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

interface VerificationRejectedBannerProps {
  onKnowMore: () => void;
}

export default function VerificationRejectedBanner({ onKnowMore }: VerificationRejectedBannerProps) {
  return (
    <Paper p="md" radius="lg" mb="xs" bg="#D84B4B33" style={{ border: "1px solid var(--mantine-color-red-3)" }}>
      <Flex justify="space-between" align="center" gap="md" wrap="wrap">
        <Flex gap="sm" align="flex-start">
          <ThemeIcon size={24} radius="xl" color="#D84B4B" variant="transparent">
            <IconAlertCircle size={20} />
          </ThemeIcon>
          <Flex direction="column">
            <Text fz="sm" fw={600} c="#D84B4B">
              Verification Rejected
            </Text>
            <Text fz="sm" c="#D84B4B">
              Your profile verification was not successful at this time. Please review the details or submit the
              required information to proceed.
            </Text>
          </Flex>
        </Flex>
        <Button color="#D84B4B" onClick={onKnowMore}>
          Know more
        </Button>
      </Flex>
    </Paper>
  );
}
